import {domain_vizr} from "../../redux/constants/constants";
//Netspace constants
export const UPLOAD_NMAP_FILES = "UPLOAD_NMAP_FILES";
export const UPLOAD_NMAP_FILE = "UPLOAD_NMAP_FILE";
export const SET_NMAP_LOADER = "SET_NMAP_LOADER";
export const SET_NETSPACE_LOADER = "SET_NETSPACE_LOADER";
export const SET_NETSPACE_SNACKBAR = "SET_NETSPACE_SNACKBAR";
export const NMAP_UPLOAD_UNSUCCESSFUL = "File upload unsuccessful";
export const GET_HOST_WITH_ALERTS = "GET_HOST_WITH_ALERTS";
export const SET_HOST_WITH_ALERT = "SET_HOST_WITH_ALERT";
export const GET_SECURITY_ALERTS = "GET_SECURITY_ALERTS";
export const SET_SECURITY_ALERTS = "SET_SECURITY_ALERTS";
export const GET_VISIBILITY = "GET_VISIBILITY"
export const SET_VISIBILITY = "SET_VISIBILITY"
export const GET_CRITICALITY = "GET_CRITICALITY";
export const SET_CRITICALITY = "SET_CRITICALITY";
export const SET_OS_TYPES = "SET_OS_TYPES";
export const GET_OS_TYPES = "GET_OS_TYPES";
export const SET_SOURCE_TYPES = "SET_SOURCE_TYPES";
export const GET_SOURCE_TYPES = "GET_SOURCE_TYPES";
export const GET_CVE_IDS = "GET_CVE_IDS";
export const SET_CVE_IDS_DASHBOARD = "SET_CVE_IDS_DASHBOARD";
export const SET_CVE_BY_SEVERITIES_DASHBOARD = "SET_CVE_BY_SEVERITIES_DASHBOARD";
export const GET_CVE_BY_SEVERITIES_DASHBOARD = "GET_CVE_BY_SEVERITIES_DASHBOARD";
export const GET_HIGHEST_CVE_SEVERITY_DASHBOARD = "GET_HIGHEST_CVE_SEVERITY_DASHBOARD";
export const SET_HIGHEST_CVE_SEVERITY_DASHBOARD = "SET_HIGHEST_CVE_SEVERITY_DASHBOARD";
export const LOADING_DATA = "Loading Data...";
export const GET_GROUP_BY = "GET_GROUP_BY";
export const SET_GROUPS = "SET_GROUPS";
export const SET_SELECTED_GROUP = "SET_SELECTED_GROUP";
export const UPDATE_SELECTED_GROUP = "UPDATE_SELECTED_GROUP";
export const SET_SELECTED_LABEL = "SET_SELECTED_LABEL";
export const SET_GROUP_COUNT = "SET_GROUP_COUNT";
export const SET_SITEMAP_EXPAND_ACCORDION = "SET_SITEMAP_EXPAND_ACCORDION";
export const SET_SITEMAP_EXPAND_ACCORDION_RESET = "SET_SITEMAP_EXPAND_ACCORDION_RESET";
export const GET_GROUP_BY_DATA = "GET_GROUP_BY_DATA";
export const SET_ACCORDION_DATA = "SET_ACCORDION_DATA";
export const DEFAULT = "DEFAULT";
export const SAVE_TAGS = "SAVE_TAGS";
export const AGENTS = "AGENTS";
export const VULNERABILITY_ID = "VULNERABILITY_ID";
export const VULNERABILITIES = "VULNERABILITIES";
export const SYSTEM_TAGS = "SYSTEM_TAGS";
export const USER_TAGS = "USER_TAGS";
export const CLOSE_NETSPACE_DRAWER = "CLOSE_NETSPACE_DRAWER";
export const OPEN_NETSPACE_DRAWER = "OPEN_NETSPACE_DRAWER";
export const SET_PAGINATION_MODEL = "SET_PAGINATION_MODEL";
export const CHANGE_TAG_MODAL_STATUS = "CHANGE_TAG_MODAL_STATUS";
export const SAVE_TAGS_URL = `${domain_vizr}/tenant/netSpace/tags?hostId=`;
export const GET_NETMAP_STATUS_URL = `${domain_vizr}/tenant/netSpace/fileStatus`;
export const GET_ACTIVE_NETMAP_URL = `${domain_vizr}/tenant/netSpace/activeSiteMapFile`;
export const GET_ACTIVE_NETMAP = 'GET_ACTIVE_NETMAP';
export const GET_NETMAP_STATUS = 'GET_NETMAP_STATUS';
export const FETCH_FILE_STATUS_CANCEL = 'FETCH_FILE_STATUS_CANCEL';
export const SET_ACTIVE_NETMAP = 'SET_ACTIVE_NETMAP';
export const SET_NETMAP_PROGRESS = 'SET_NETMAP_PROGRESS';
export const SET_FILE_EDITABLE = 'SET_FILE_EDITABLE';
export const FILE_COMPLETED_STATUS = ['PROCESSED','ERROR'];
export const SET_RELOAD_NETSPACE = 'SET_RELOAD_NETSPACE';
export const GET_CVE_LIST_BY_SEVERITY = "GET_CVE_LIST_BY_SEVERITY";
export const SET_CVE_LIST_BY_SEVERITY = "SET_CVE_LIST_BY_SEVERITY";
export const UPDATE_HOST_STATUS = "UPDATE_HOST_STATUS";

export const icons = {
    "DB": '/dataSourceIcons/db.svg',
    "API": '/dataSourceIcons/api.svg',
    "LDAP": '/dataSourceIcons/ldap.png',
    "MAIL": '/dataSourceIcons/smtp.png',
    "WINDOWS": '/dataSourceIcons/win.svg',
    "LINUX": '/dataSourceIcons/linux.svg',
    "EMBEDDED": '/dataSourceIcons/embedded.png'
  };

export const desiredOrderAlerts = ['HIGH', 'MEDIUM', 'LOW', 'INFORMATIONAL'];
export const desiredOrderMonitor = ['NO', 'UNKNOWN', 'YES', 'DECOMMISSIONED']
export const desiredOrderCVESeverity = ['CRITICAL', 'HIGH', 'MEDIUM', 'LOW', 'INFORMATIONAL'];
export const desiredOrderCriticality = ['highSeverityHosts', 'mediumSeverityHosts', 'lowSeverityHosts'];
export const formFinalURL = (
  selected_group,
  accordionKey,
  pageNo,
  pageSize,
  parentSeverity,
) => {
  const prefix = GROUP_DATA_URL[selected_group];
  const suffix = GROUP_DATA_URL_SUFFIX[selected_group];

  // Special case: CVE ID inside vulnerabilities
  if (selected_group === "VULNERABILITY_ID" && parentSeverity) {
    return `${prefix}?size=${pageSize}&page=${pageNo}&severity=${parentSeverity}&cveId=${accordionKey}`;
  }

  return prefix + `?size=${pageSize}&page=${pageNo}` + suffix + accordionKey;
};
export const GROUP_DATA_URL = {
    TYPE: `${domain_vizr}/tenant/netSpace/groupByHostType`,
    OS: `${domain_vizr}/tenant/netSpace/groupByOsName`,
    SENSITIVE_PORTS: `${domain_vizr}/tenant/netSpace/groupByPortSeverity`,
    TAG: '',
    ALERTS: `${domain_vizr}/tenant/netSpace/groupByAlertSeverity`,
    MONITORING: `${domain_vizr}/tenant/netSpace/groupByMonitorStatus`,
    DEFAULT: `${domain_vizr}/tenant/netSpace/hosts`,
    AGENTS: `${domain_vizr}/tenant/netSpace/groupBySourceType`,
    VULNERABILITY_ID: `${domain_vizr}/tenant/netSpace/groupByCveId`,
    VULNERABILITIES: `${domain_vizr}/tenant/netSpace/groupByCveSeverity`,
    VULNERABLE_HOSTS: `${domain_vizr}/tenant/netSpace/groupByMaxCveSeverity`
};
export const GROUP_DATA_URL_SUFFIX = {
    TYPE: `&hostType=`,
    OS: `&osName=`,
    SENSITIVE_PORTS: `&severity=`,
    TAG: '',
    ALERTS: `&alertType=`,
    MONITORING: `&status=`,
    DEFAULT: ``,
    AGENTS: `&sourceType=`,
    VULNERABILITY_ID: `&cveId=`,
    VULNERABILITIES: `&severity=`,
    VULNERABLE_HOSTS: `&severity=`
};
export const GROUP_COUNT_URL = {
    TYPE: `${domain_vizr}/tenant/netSpace/hostTypes`,
    OS: `${domain_vizr}/tenant/netSpace/osFamilies`,
    SENSITIVE_PORTS: `${domain_vizr}/tenant/netSpace/severities`,
    TAG: '',
    ALERTS: `${domain_vizr}/tenant/netSpace/hostsWithAlerts`,
    MONITORING: `${domain_vizr}/tenant/netSpace/monitoringStatus`,
    DEFAULT: '',
    AGENTS: `${domain_vizr}/tenant/netSpace/sourceTypes`,
    VULNERABILITY_ID: `${domain_vizr}/tenant/netSpace/cveIds`,
    VULNERABILITIES: `${domain_vizr}/tenant/netSpace/cveBySeverities`,
    VULNERABLE_HOSTS: `${domain_vizr}/tenant/netSpace/countByHighestCveSeverity`
};
export const criticalityMap = {
    'highSeverityHosts': 'High',
    'mediumSeverityHosts': 'Medium',
    'lowSeverityHosts': 'Low'
};
export const MonitorMap = {
    'NO': 'Not Monitored',
    'UNKNOWN': 'Unknown',
    'YES': 'Monitored',
    'DECOMMISSIONED': 'Decommissioned',
};
export const cveBySeverityMap = {
    'CRITICAL': 'Critical',
    'HIGH': 'High',
    'MEDIUM': 'Medium',
    'LOW': 'Low',
}
export const sensitivityMap = {
    'CRITICAL': 'Critical',
    'HIGH': 'High',
    'MEDIUM': 'Medium',
    'LOW': 'Low',
    'INFORMATIONAL': "Informational"
};
export const criticalityBGColorMap = {
    'highSeverityHosts': '#991530',
    'mediumSeverityHosts': '#993300',
    'lowSeverityHosts': '#082B80'
};
export const criticalityBarColorMap = {
    'highSeverityHosts': '#FF2251',
    'mediumSeverityHosts': '#FF8429',
    'lowSeverityHosts': '#081981'
};
export const NMAP_FILE_UPLOAD = `${domain_vizr}/tenant/netSpace/upload`;
export const HOST_WITH_ALERT_URL = `${domain_vizr}/tenant/netSpace/hostsWithAlerts`;
export const SECURITY_ALERTS_URL = `${domain_vizr}/tenant/netSpace/alertSeverities`;
export const VISIBILITY_URL = `${domain_vizr}/tenant/netSpace/monitoringStatus`;
export const CRITICALITY_URL = `${domain_vizr}/tenant/netSpace/hostCriticalityCounts`;
export const GROUPS_URL = `${domain_vizr}/tenant/netSpace/groups`;
export const GET_SECOND_TAGS_DROPDOWN = `GET_USER_TAGS_DROPDOWN`;
export const getSecondDropdownAPI = (selected) => {
    return `${domain_vizr}/tenant/netSpace/userCodes?tagType=${selected}`
}
export const getSecondTagsDropdownValuesAPI = (selected) => {
  return `${domain_vizr}/tenant/netSpace/userTags?tagType=${selected}`;
};

export const securityLegend = [
    {class: 'criticalAlert', label: 'Critical'},
    {class: 'highAlert', label: 'High'},
    {class: 'mediumAlert', label: 'Medium'},
    {class: 'lowAlert', label: 'Low'}
];

export const alertStatusLegend = [
    {class: 'newStatus', label: 'New', filter: 'NEW'},
    {class: 'inProgressStatus', label: 'In Progress', filter: 'IN_PROGRESS'},
    {class: 'resolvedStatus', label: 'Resolved', filter: 'RESOLVED'},
    {class: 'closedStatus', label: 'Closed', filter: 'CLOSED'}
];


export const alertStatusMap = {
  New: "NEW",
  IN_PROGRESS: "In Progress",
  Closed: "Closed",
  CLOSED: "Closed",
  NEW: "New",
  RESOLVED: "Resolved",
};
export const visibilityLegend = [
    {class: 'highUser', label: 'Not Monitored', isMonitored: 'NO'},
    {class: 'mediumUser', label: 'Unknown', isMonitored: 'UNKNOWN'},
    {class: 'lowUser', label: 'Monitored', isMonitored: 'YES'},
    {class: 'decommissionedUser', label: 'Decommissioned', isMonitored: 'DECOMMISSIONED'},
];
export const defaultPaginationModel = {
    pageSize: 20,
    page: 0,
};
export const secondDropdownValues = [USER_TAGS, SYSTEM_TAGS];
export const SET_USER_TAGS_DROPDOWN = 'SET_USER_TAGS_DROPDOWN';
export const SET_SYSTEM_TAGS_DROPDOWN = 'SET_SYSTEM_TAGS_DROPDOWN';
export const GET_TAG_VALUES = "GET_TAG_VALUES";
export const GET_SUB_TAG_DATA = "GET_SUB_TAG_DATA";
export const getSubTagDataAPI = (selectedTag, page, size) => {
    return  `${domain_vizr}/tenant/netSpace/groupByUserTag?tagType=${selectedTag}&page=${page}&size=${size}`;
}
export const getTagName = {
    SYSTEM_TAGS: "SYSTEM",
    USER_TAGS: "USER",
  }
export const SET_SECOND_TAG_VALUE = "SET_SECOND_TAG_VALUE";
export const SET_NETSPACE_TABLE_FILTERS = "SET_NETSPACE_TABLE_FILTERS";
export const SET_NETSPACE_FILTER_OPTIONS  = "SET_NETSPACE_FILTER_OPTIONS";

export const DELETE_USER_TAG = "DELETE_USER_TAG";
export const DELETE_USER_TAG_URL = (id) => `${domain_vizr}/tenant/netSpace/deleteTags/${id}`;
export const flexHeaders = ["CVE Score", "CVE Severity"]
export const allowedTypeSource = ["Sentinel"]
export const FETCH_CVE_BY_SEVERITIES = "FETCH_CVE_BY_SEVERITIES";
export const GET_CVE_BY_SEVERITIES = `${domain_vizr}/tenant/netSpace/cveBySeverities`;
export const SET_CVE_BY_SEVERITIES = "SET_CVE_BY_SEVERITIES";
export const FETCH_HIGHEST_CVE_SEVERITY = "FETCH_HIGHEST_CVE_SEVERITY";
export const GET_HIGHEST_CVE_SEVERITY = `${domain_vizr}/tenant/netSpace/countByHighestCveSeverity`;
export const SET_HIGHEST_CVE_SEVERITY = "SET_HIGHEST_CVE_SEVERITY";
export const SET_CVE_IDS = "SET_CVE_IDS";
export const CVE_ID_INFO = (id) => `https://nvd.nist.gov/vuln/detail/${id}`
export const sensitiveGroups = ["ALERTS", "VULNERABILITIES", "VULNERABLE_HOSTS"]
export const severityLightColorMap = {
  CRITICAL: "#ee4d3f",
  HIGH: "#ff9eb3",
  MEDIUM: "#ffbf8c",
  LOW: "#80caff",
  INFORMATIONAL: "#11b7d6",
};
export const severityColorMap = {
  CRITICAL: "#e22d1b",
  HIGH: "#ff2251",
  MEDIUM: "#FF8421",
  LOW: "#081981",
  INFORMATIONAL: "#11b7d6"
};

// ---- NetSpace side drawer Alerts table -----
export const SET_SIDE_DRAWER_ALERTS = "SET_SIDE_DRAWER_ALERTS";
export const GET_SIDE_DRAWER_ALERTS = "GET_SIDE_DRAWER_ALERTS";
export const getSideDrawerAlertsAPI = (hostId, page, size) => {
    return `${domain_vizr}/tenant/netSpace/alertInfo?hostId=${hostId}&page=${page}&size=${size}`;
}

export const sideDrawerColumns = [
  {
    field: "severity",
    headerName: "Severity",
    flex: 1,
    renderCell: (params) => (
      <div
        className="severity-cell"
        style={{
          backgroundColor: severityColorMap[params.value],
          color: "#fff",
          padding: "5px",
          borderRadius: "4px",
          textAlign: "center",
        }}
      >
        {params.value}
      </div>
    ),
  },
  {
    field: "status",
    headerName: "Status",
    flex: 1,
  },
  {
    field: "alertName",
    headerName: "Alert Name",
    flex: 2,
    renderCell: (params) => (
      <div className="alert-name-cell">{params.value}</div>
    ),
  },
];

export const alertsOrderGroups = ['ALERTS', 'VULNERABILITIES', 'VULNERABLE_HOSTS'] 

export const UPDATE_HOST_STATUS_URL = `${domain_vizr}/tenant/netSpace/updateHostStatus`;